// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NotFound-module-wrapper-IsOHI{display:flex;flex-direction:column;justify-content:center;align-items:center;width:100%;min-height:calc(100vh - 204px);background-repeat:no-repeat;background-position:center;background-size:cover}.NotFound-module-content-3-Hme{display:flex;flex-direction:column;align-items:center;gap:40px;text-align:center}.NotFound-module-title-zozU6{font-size:26px;line-height:55px;font-weight:var(--weight-light);padding-bottom:16px}@media(min-width: 960px){.NotFound-module-title-zozU6{font-size:32px}}@media(min-width: 1280px){.NotFound-module-title-zozU6{font-size:45px}}.NotFound-module-subtitle-1gT3G{font-size:20px;line-height:38px;font-weight:var(--weight-light)}@media(min-width: 1280px){.NotFound-module-subtitle-1gT3G{font-size:26px}}", ""]);
// Exports
exports.locals = {
	"wrapper": "NotFound-module-wrapper-IsOHI",
	"content": "NotFound-module-content-3-Hme",
	"title": "NotFound-module-title-zozU6",
	"subtitle": "NotFound-module-subtitle-1gT3G"
};
module.exports = exports;
